import { skipToken } from '@reduxjs/toolkit/query';
import { useMemo } from 'react';
import { useGetEmployeesListWithFiltersQuery } from 'store/api/employees';
import { MatterPricelist } from 'types/pricelists';
import { pricedPeopleOf } from './matterPricingCopy';

/**
 * The people a source case's lists price who are no longer active, for a case started from it to leave their
 * personal rates out: the server refuses a new case that prices someone inactive. Undefined until it is known.
 */
export function useInactivePricedPeople(sourcePricelists: MatterPricelist[] | undefined): {
    inactiveEmployeeIds: Set<number> | undefined;
    isLoading: boolean;
} {
    const pricedPeople = useMemo(() => pricedPeopleOf(sourcePricelists ?? []), [sourcePricelists]);
    const { data: activePricedEmployees, isLoading } = useGetEmployeesListWithFiltersQuery(
        pricedPeople.length > 0
            ? { page: 0, pageSize: pricedPeople.length, filters: `id=in=(${pricedPeople.join(',')})` }
            : skipToken
    );
    const inactiveEmployeeIds = useMemo(() => {
        if (!activePricedEmployees) {
            return undefined;
        }
        const activeIds = new Set(activePricedEmployees.content.map((employee) => employee.id));
        return new Set(pricedPeople.filter((employeeId) => !activeIds.has(employeeId)));
    }, [activePricedEmployees, pricedPeople]);
    return { inactiveEmployeeIds, isLoading };
}
